import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { IDataGridElement } from 'shared';
import { ComboList } from 'src/app/core/types/server-response';


@Component({
  selector: 'app-modal-cambiar-local-universidad',
  templateUrl: './modal-cambiar-local-universidad.component.html',
  styleUrls: ['./modal-cambiar-local-universidad.component.scss']
})
export class ModalCambiarLocalUniversidadComponent implements OnInit {

  comboLists = { locales: new ComboList() };

  gridLocales: IDataGridElement<any> = {
    loading: false,
    definition: {
      columns: [
        { label: 'Nombre del local', field: 'nombreLocal' },
        { label: 'Seleccionar', field: 'tpl-opciones', template: 'tpl-opciones', thStyle: { width: '30px' } }
      ]
    },
    source: {
      items: [{ nombreLocal: 'Local 01' }, { nombreLocal: 'Local 02' }],
      page: 1,
      pageSize: 10,
      total: 2
    }
  };

  form: FormGroup;

  localSeleccionado: any = null;

  constructor(
    public dialogRef: MatDialogRef<ModalCambiarLocalUniversidadComponent>,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm = () => {
    this.form = this.formBuilder.group({
      idLocal: [null],
    });
  }

  handleClose = () => {
    this.dialogRef.close();
  }

  handleAceptar = () => {
    this.dialogRef.close();
  }

  handleChangeLocal = (e) => {
    this.localSeleccionado = e.value;
  }

}
